import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-sm transition-all duration-300 font-medium tracking-wide focus:outline-none focus:ring-2 focus:ring-sage-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-charcoal-900 text-cream-100 hover:bg-sage-500 hover:shadow-soft',
    secondary: 'bg-cream-200 text-charcoal-900 hover:bg-cream-50',
    outline: 'border border-taupe-300 bg-transparent text-charcoal-900 hover:border-sage-500 hover:text-sage-600',
    ghost: 'bg-transparent text-charcoal-900 hover:bg-cream-200 hover:text-sage-600'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-18">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-19" />}
      {children}
    </button>;
}